module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mission-statement"
  }, [_c('h2', [_vm._v("About this site")]), _vm._v(" "), _c('p', [_vm._v("Since falling in love with Critical Role I've loved what others have created in Art, Cosplay, and much more. I always found that I had a hard time to easily search for Critical Role related items to purchase.")]), _vm._v(" "), _c('p', [_vm._v("One goal of this website is to help those who want to purchase Critical Role commissions, dice, dice bags, coffee, and much more.")]), _vm._v(" "), _c('p', [_vm._v("The other goal of this site is that I really wanted to signal boost all of these wondeful creators!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7173848f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MissionStatement.vue
// module id = 759
// module chunks = 0